import React, { useState, useEffect, useMemo } from "react";

// Компонент для анімованого фону з обличчями сторінки "Логін"
const AnimatedFaces = () => {
  // Стан для зберігання масиву імпортованих зображень
  const [faceImages, setFaceImages] = useState([]);
  const numberOfBoxes = 6; // Кількість анімованих блоків

  // Ефект, що виконується один раз при монтуванні компонента
  useEffect(() => {
    // Допоміжна функція для імпорту всіх файлів з контексту Webpack
    function importAll(r) {
      return r.keys().map(r);
    }

    try {
      // Динамічно імпортуємо всі зображення з папки 'assets/faces'
      const images = importAll(
        require.context("assets/faces", false, /\.(png|jpe?g|svg|gif)$/)
      );
      setFaceImages(images);
    } catch (error) {
      console.error(
        "Could not import images. Check the path in require.context.",
        error
      );
      setFaceImages([]); // Встановлюємо порожній масив у разі помилки
    }
  }, []);

  // Генеруємо випадкові зображення для кожного блоку
  const randomFacesForBoxes = useMemo(() => {
    if (faceImages.length === 0) return [];

    // Створюємо масив потрібної довжини і заповнюємо його випадковими зображеннями
    return Array.from({ length: numberOfBoxes }).map(
      () => faceImages[Math.floor(Math.random() * faceImages.length)]
    );
  }, [faceImages]);

  return (
    <ul className="box-area">
      {randomFacesForBoxes.map((faceSrc, index) => (
        <li key={index}>
          <img src={faceSrc} alt={`Developer face ${index + 1}`} />
        </li>
      ))}
    </ul>
  );
};

export default AnimatedFaces;
